export const versionStatus=(row,product)=>{
 const actual=product==='sismed'?row.sismedVersion:row[product+'Actual'],available=row[product+'Disponible'];
 if(product==='sismed'){
  if(!actual?.trim())return {key:'unknown',label:'Sin reporte',color:'default'};
  if(!available?.trim())return {key:'unknown',label:'Sin versión de referencia',color:'default'};
  const normalize=v=>v.trim().replace(/\s+/g,' ').toUpperCase();
  return normalize(actual)===normalize(available)?{key:'reported',label:'Actualizado · reportado',color:'success'}:{key:'pending',label:'Versión diferente',color:'warning'};
 }
 if(!actual)return {key:'unknown',label:'Sin reporte',color:'default'};
 if(row[product+'Release'])return Number(row.equipos)>0&&Number(row[product+'Confirmados'])===Number(row.equipos)?{key:'current',label:'Confirmado',color:'success'}:{key:'pending',label:'Pendiente',color:'warning'};
 if(!available)return {key:'unknown',label:'Sin versión asignada',color:'default'};
 return actual===available?{key:'reported',label:'Coincide · reportado',color:'info'}:{key:'pending',label:'Pendiente',color:'warning'};
};
